<template>
  <div class="app-version">
    <div class="app-version-logo">
      <div class="logo-cma-about"></div>
    </div>
    <h4 class="app-version-title">{{ $t("HELP_VERSION").Title }}</h4>

    <div class="app-version-list">
      <div class="app-version-item">
        <div class="app-version-item-icon">
          <feather-icon icon="TagIcon" size="16" />
        </div>
        <span class="app-version-item-label">{{ $t("HELP_VERSION").Item_Version }}</span>
        <span class="app-version-item-value">{{ version }}</span>
      </div>
      <div class="app-version-item">
        <div class="app-version-item-icon">
          <feather-icon icon="GlobeIcon" size="16" />
        </div>
        <span class="app-version-item-label">{{ $t("HELP_VERSION").Item_Browser }}</span>
        <span class="app-version-item-value">{{ browserName }}</span>
      </div>
      <div class="app-version-item">
        <div class="app-version-item-icon">
          <feather-icon icon="MonitorIcon" size="16" />
        </div>
        <span class="app-version-item-label">{{ $t("HELP_VERSION").Item_System }}</span>
        <span class="app-version-item-value">{{ platform }}</span>
      </div>
      <div class="app-version-item">
        <div class="app-version-item-icon">
          <feather-icon icon="MaximizeIcon" size="16" />
        </div>
        <span class="app-version-item-label">{{ $t("HELP_VERSION").Item_Resolution }}</span>
        <span class="app-version-item-value">{{ screenSize }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import browserInfoHelper from "@/helpers/browser-info-helper";

export default {
  computed: {
    platform() {
      return browserInfoHelper.getPlatform();
    },
    screenSize() {
      return browserInfoHelper.getScreenSize();
    },
    browserName() {
      return browserInfoHelper.getBrowserName();
    },
    version() {
      // Versão do deploy com a data (vue.config.js); config.json fica só como fallback
      return process.env.VUE_APP_VERSION || this.$config.version;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-version {
  padding: 8px 4px;
}

.app-version-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;

  .logo-cma-about {
    position: static !important;
    margin: 0 !important;
    left: auto !important;
  }
}

.app-version-title {
  text-align: center;
  font-weight: 600;
  margin-bottom: 24px;
}

.app-version-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.app-version-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: rgba(115, 103, 240, 0.05);
  border: 1px solid rgba(115, 103, 240, 0.12);
}

.app-version-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #7367f0;
  color: #fff;
  flex-shrink: 0;
}

.app-version-item-label {
  flex: 1;
  color: rgba(0, 0, 0, 0.6);
}
.dark-layout .app-version-item-label {
  color: rgba(255, 255, 255, 0.65);
}

.app-version-item-value {
  font-weight: 600;
  text-align: right;
  overflow-wrap: anywhere;
}
</style>
